import { FieldConfigs } from '../shared/components/FormType';
import { PRODUCT_CATEGORY } from '../data/enums';

export const Search = {
    searchText: 'Tìm kiếm theo từ khoá Mã khách hàng, Tên khách hàng',
};

export const CustomerTableColumns = [
    { text: 'Mã khách hàng', icon: <></> },
    { text: 'Tên khách hàng', icon: <></> },
    { text: 'Danh mục', icon: <></> },
    { text: 'Tổng sản phẩm đã mua', icon: <></> },
    // { text: "Số điện thoại", icon: <></> },
    // { text: "Số fax", icon: <></> },
    // { text: "Email", icon: <></> },
    { text: 'Cấp độ', icon: <></> },
    // { text: "Người liên hệ", icon: <></> },
    // { text: "Tỉnh/Thành phố", icon: <></> },
    { text: 'Tổng đơn hàng', icon: <></> },
    { text: 'Đơn hàng hiện tại', icon: <></> },
];

export const AddCustomerTableColumns = [
    { text: 'Mã khách hàng', icon: <></> },
    { text: 'Tên khách hàng', icon: <></> },
    { text: 'Danh mục', icon: <></> },
    { text: 'Số điện thoại', icon: <></> },
    { text: 'Email', icon: <></> },
];

export const CreateCustomerTitleBar = {
    title: 'Tạo mới khách hàng',
    cancelButton: 'Huỷ bỏ',
    addButton: 'Lưu khách hàng',
};

export const DetailCustomerTitleBar = {
    deleteButton: 'Xoá khách hàng',
    saveButton: 'Lưu Khách Hàng',
    createOrderButton: 'Tạo đơn hàng sản phẩm',
};

export const DeleteCustomerModal = {
    title: 'Xoá khách hàng',
    context: 'Bạn có muốn xoá người liên hệ khỏi danh sách không? \n' + 'Hành động này sẽ không được hoàn tác.',
};

export const WarningCustomerModal = {
    title: 'Huỷ bỏ',
    context:
        'Thông tin bạn đã cung cấp sẽ không được lưu, bạn có chắc chắn ' +
        'muốn huỷ bỏ không? Hành động này sẽ không được hoàn tất.',
};

export const basicFields: FieldConfigs[] = [
    {
        label: 'Đơn vị nội bộ',
        type: 'toggle',
        key: 'is_internal',
        required: false,
        hideToggleText: true,
    },
    {
        label: 'Tên khách hàng',
        type: 'text',
        key: 'name',
        required: true,
    },
    {
        label: 'Danh mục',
        type: 'multiSelect',
        key: 'category',
        required: false,
        options: [
            { text: 'Phuy', value: PRODUCT_CATEGORY.BARREL },
            { text: 'Thùng', value: PRODUCT_CATEGORY.VESSEL },
            { text: 'Cơ Khí Ô Tô', value: PRODUCT_CATEGORY.VEHICLE },
        ],
    },
    {
        label: 'Mã khách hàng',
        type: 'text',
        key: 'customer_code',
        required: false,
    },
    {
        label: 'Số điện thoại',
        type: 'text',
        key: 'phone',
        required: false,
        validation: 'customerPhone',
    },
    { label: 'Mã số thuế', type: 'text', key: 'tax_id', required: false, validation: 'customerTaxId' },
    {
        label: 'Nhân viên bán hàng phụ trách',
        type: 'search',
        key: 'sales_staff',
        required: false,
        dataApi: "/users/?role=SALE_STAFF",
        noDataText: "Không tìm thấy nhân viên bán hàng",
        showAll: true
    },
    {
        label: 'Email',
        type: 'text',
        key: 'email',
        required: false,
        validation: 'email',
    },
    { label: 'Địa chỉ', type: 'text', key: 'address', required: false },
    { label: 'Số ngày nợ', type: 'text', key: 'payable_days', required: false, validation: 'customerNumber' },
    { label: 'Hạn mức công nợ', type: 'text', key: 'credit_limit', numeric: true, required: false, validation: 'customerNumber' },
];

export const contactFields: FieldConfigs[] = [
    {
        label: 'Người liên hệ mặc định',
        type: 'toggle',
        key: 'is_default',
        required: false,
        hideToggleText: true,
    },
    { label: 'Họ và tên', type: 'text', key: 'name', required: false },
    {
        label: 'Số điện thoại',
        type: 'text',
        key: 'phone',
        required: false,
        validation: 'customerPhone',
    },
    {
        label: 'Email',
        type: 'text',
        key: 'email',
        required: false,
        validation: 'email',
    },
    { label: 'Vai trò', type: 'text', key: 'position', required: false },
];